{{ label }}
<input #fileInput type="file" class="d-none" (change)="handleFileInput($event.target)" [accept]="acceptTypes">
<button [disabled]="control.disabled" type="button" class="ml-5 btn btn-fill btn-sm btn-primary" (click)="fileInput.click()">
  <i class="fa fa-cloud-upload"></i>
  {{ selectFileText ?? '' }}
</button>
@if (!fileName) {
  <small class="ms-3" [class.text-danger]="control.invalid && control.touched">Keine Datei gewählt</small>
}
@if (fileName) {
  <small class="ms-3">{{ fileName }}</small>
}
